export function dlPush(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
}

function interceptPush() {
    if (!window || window.__dlPushIntercepted) return;
    window.__dlPushIntercepted = true;
    window.dataLayer = window.dataLayer || [];
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
        console.dir(arguments[0]);
        return originalPush.apply(this, arguments);
    };
}

if (window && window.location && window.location.origin.includes('.test')) {
    interceptPush();
}

export function qsToDatalayer(param = 'dlev') {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(param);
    if (!paramValue) return;

    try {
        dlPush(JSON.parse(paramValue));
    } catch { }
}

export function extractField(className) {
    const el = document.querySelector(`.${className} .ginput_container input`);
    return el ? el.value : undefined;
}

export function ecomEvent(init = {}) {
    const { id, currency = 'EUR', ...rest } = init;
    const event = { ...rest };

    if (id || currency) initialize(id, currency);

    function ecomDerived() {
        const value = (event.items ?? []).reduce((sum, item) => {
            return sum + (item.price || 0) * (item.quantity || 1);
        }, 0);
        return {
            value,
        };
    }

    function get(other = {}) {
        return { event: 'purchase', ...other, ecommerce: { ...ecomDerived(), ...event } };
    }

    function initialize(tid, currency = 'EUR') {
        if (tid) set('transaction_id', tid);
        if (currency) set('currency', currency);
    }

    function set(key, value) {
        event[key] = value;
    }

    function resetProducts() {
        event.items = [];
    }

    function addProduct(name, id, price, quantity = 1, other = {}) {
        event.items ||= [];
        event.items.push({ ...other, item_name: name, item_id: id, price, quantity });
    }

    function deleteProduct(name) {
        if (!event.items) return;
        event.items = event.items.filter(p => p.item_name !== name && p.item_id !== name);
    }

    function push(other, overwrite = true) {
        const dlEvent = get(other);
        if (!overwrite && window.dataLayer) {
            const prev = window.dataLayer?.find?.(e => e.event === dlEvent.event);
            if (prev) return;
        }
        dlPush(dlEvent);
    }

    function write(selector, other) {
        const el = document.querySelector(selector);
        if (!el) return;
        const data = JSON.stringify(get(other));
        switch (el.tagName) {
            case 'INPUT':
            case 'TEXTAREA':
                el.value = data;
                return;
            default:
                el.textContent = data
                return;
        }

    }

    return { init: initialize, event, get, set, resetProducts, addProduct, deleteProduct, push, write }
}